import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const CustomEcommerceWebsiteSolutionsInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Custom E-commerce Website Solutions in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Tailored for Your Brand</Subheading>}
        heading={
          <Heading>
            Custom{" "}
            <span tw="text-primary-500">E-commerce Website Solutions</span> in
            Al Barsha
          </Heading>
        }
        description={
          <Description>
            MilaajBrandset delivers custom e-commerce website solutions in **Al
            Barsha**, designed to match your unique business needs, enhance
            customer engagement, and drive sales.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1607082349566-187342175e2f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // E-commerce storefront on tablet
          "https://images.unsplash.com/photo-1546213290-e1b492ab3eee?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile shopping app
          "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Online store dashboard
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Build Your Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Go Custom?</Subheading>}
        heading="Bespoke E-commerce Excellence"
        description="Our custom solutions set your store apart."
        cards={[
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Unique Designs",
            description: "Reflect your brand’s identity.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Tailored Features",
            description: "Built for your business goals.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Scalable Systems",
            description: "Grow without limits.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure Framework",
            description: "Safe and reliable transactions.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile-Optimized",
            description: "Seamless on any device.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Al Barsha Experts",
            description: "Local customization leaders.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Create</Subheading>}
        heading="Our Custom E-commerce Development Process"
        description={
          <Description>
            We craft your unique store with precision:
            <ul tw="mt-4 list-disc pl-6">
              <li>Discovery: Understand your vision and goals.</li>
              <li>Design: Create bespoke, brand-aligned visuals.</li>
              <li>Development: Build custom features and integrations.</li>
              <li>Testing: Ensure functionality and performance.</li>
              <li>Launch: Deploy your tailored store.</li>
              <li>Support: Provide ongoing optimization.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1559028012-481c04fa702d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Web development process
          "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Team planning e-commerce strategy
          "https://images.unsplash.com/photo-1472437774355-71ab6752b434?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Dubai business district
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Our Achievements</Subheading>}
        heading="Custom E-commerce Wins in Al Barsha"
        description="Our tailored stores deliver results."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Surge",
            description: "35% revenue increase.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Unique Impact",
            description: "20% more customer engagement.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Praise",
            description: "96% satisfaction rate.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Unique?</Subheading>}
        heading="Custom E-commerce Website Solutions in Al Barsha"
        description={
          <Description>
            MilaajBrandset offers custom e-commerce website solutions in Al
            Barsha, built to elevate your brand and maximize growth. Contact us
            to create your bespoke store today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1552581234-26160f608093?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Online payment/e-commerce success
          "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Dubai skyline with Burj Khalifa
          "https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Custom website design concept
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
